type KeyValue = string | number | boolean | Array<any> | Object;

export enum StorageType {
    session = 'session',
    local = 'local',
}
export interface IWebStorage {
    storageValue: KeyValue;
}
export class WebStorage implements IWebStorage {
    private webStorage: Storage | undefined;
    private key: string;
    constructor(key: KeyValue, storageType: StorageType) {
        if (typeof window !== 'undefined' && typeof Storage === 'function') {
            this.webStorage = window[`${storageType}Storage`];
        }
        this.key = typeof key === 'string' ? key : JSON.stringify(key);
    }

    set storageValue(value: KeyValue) {
        const stringValue =
            typeof value === 'string' ? value : JSON.stringify(value);
        try {
            this.webStorage?.setItem(this.key, stringValue);
        } catch (error) {
            console.error(error);
        }
    }

    get storageValue() {
        let result: string | null | undefined = '';
        try {
            result = this.webStorage?.getItem(this.key);
            try {
                result = result && JSON.parse(result);
            } catch (error) {
                console.info(error);
            }
        } catch (error) {
            console.error(error);
        }
        return result as KeyValue;
    }
}
